<div class="generales">
  <div fxLayout="row" fxLayoutAlign="center stretch" >
  <mat-spinner class="cargando" *ngIf="cargando"></mat-spinner>
  </div>

  <div *ngIf="!cargando">
  <h1 class="titutlo">{{titulo}}</h1>
  <div fxLayout="column" fxLayoutAlign="center center" >

  <!-- <img class="logoCliente" src="assets/images/norm35/resuTest/DEMO_ENCUESTA2.jpg" alt=""> -->

    <!-- SECCION1 -->
    <table mat-table [dataSource]="tablaRespuestas" class="mat-elevation-z8">
      <ng-container matColumnDef="orden">
        <th mat-header-cell *matHeaderCellDef id="respuestas"></th>
        <td mat-cell *matCellDef="let element" style="width: 5%; text-align: left;"> {{element.NumStatementResult}} </td>
      </ng-container>

      <ng-container matColumnDef="pregunta">
        <th mat-header-cell *matHeaderCellDef id="respuestas"> {{'SECCIONES.FR_RESPUESTAS_ENCUESTA.PREGUNTA' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.StatementName}} </td>
      </ng-container>

      <ng-container matColumnDef="siempre">
        <th mat-header-cell *matHeaderCellDef style="background-color: #FF0000;"><p id="titulos"> {{'SECCIONES.FR_RESPUESTAS_ENCUESTA.SIEMPRE' | translate}} </p></th>
        <td mat-cell *matCellDef="let element" style="width: 7.5%;" id="respuestas"> {{element.ResponseValueAlways}} </td>
      </ng-container>

      <ng-container matColumnDef="casi siempre">
        <th mat-header-cell *matHeaderCellDef style="background-color: #FFC000;"> <p id="titulos">{{'SECCIONES.FR_RESPUESTAS_ENCUESTA.CASI_SIEMPRE' | translate}}</p> </th>
        <td mat-cell *matCellDef="let element" style="width: 7.5%;" id="respuestas"> {{element.ResponseValueUsually}} </td>
      </ng-container>

      <ng-container matColumnDef="algunas veces">
        <th mat-header-cell *matHeaderCellDef style="background-color: #FFFF00;"><p id="titulos"> {{'SECCIONES.FR_RESPUESTAS_ENCUESTA.ALGUNAS_VECES' | translate}} </p></th>
        <td mat-cell *matCellDef="let element" style="width: 7.5%;" id="respuestas"> {{element.ResponseValueSometimes}} </td>
      </ng-container>

      <ng-container matColumnDef="casi nunca">
        <th mat-header-cell *matHeaderCellDef style="background-color: #92D050;"><p id="titulos"> {{'SECCIONES.FR_RESPUESTAS_ENCUESTA.CASI_NUNCA' | translate}} </p></th>
        <td mat-cell *matCellDef="let element" style="width: 7.5%;" id="respuestas"> {{element.ResponseValueAlmostNever}} </td>
      </ng-container>

      <ng-container matColumnDef="nunca">
        <th mat-header-cell *matHeaderCellDef style="background-color: #00b0f0;"><p id="titulos"> {{'SECCIONES.FR_RESPUESTAS_ENCUESTA.NUNCA' | translate}} </p></th>
        <td mat-cell *matCellDef="let element" style="width: 7.5%;" id="respuestas"> {{element.ResponseValueNever}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table> <br> <br>

  </div>
  </div>
  </div>
